export let table_GroupBorders = "$gUGkc";
export let table_GroupAccessibility = "YLVvcb";
export let report_GroupButton = "GP6Bfd";
export let teamsChat_Group = "kM5KGe";
export let names_Group = "wlpCwd";
export let table_GroupInsert = "lkvIQ";
export let table_GroupStructure = "zswo2d";
export let pictureFormatting_Group = "z$xA5b";
export let pictureText_Group = "BOab_c";
export let pictureSize_Group = "tIMyIe";
export let pictureMisc_Group = "uHV2kd";
export let spamAddins_GroupButton = "oNnvYc";
export let sendReceive_Group = "ZSE7qc";
export let preferences_Group = "iOiA6c";
export let viewArrangement_Group = "Fz4jpe";
export let currentView_Group = "EG0F7";
export let groups_GroupButton = "Q67TMc";
export let apps_GroupButton = "sRA8D";
export let addIn_GroupButton = "oFLUMc";
export let protection_GroupButton = "RqJRob";
export let restore_Group = "kMV0Nb";
export let folderProperties_Group = "fkTPUe";
export let focusedInbox_Group = "Hvp6Gc";
export default {table_GroupBorders,table_GroupAccessibility,report_GroupButton,teamsChat_Group,names_Group,table_GroupInsert,table_GroupStructure,pictureFormatting_Group,pictureText_Group,pictureSize_Group,pictureMisc_Group,spamAddins_GroupButton,sendReceive_Group,preferences_Group,viewArrangement_Group,currentView_Group,groups_GroupButton,apps_GroupButton,addIn_GroupButton,protection_GroupButton,restore_Group,folderProperties_Group,focusedInbox_Group};